import cacheAdapter from './cacheAdapter';

const config = {
  timeout: 5 * 60 * 1000,
  baseURL: `${window.__POWERED_BY_QIANKUN__ ? BUILD_VARS.QUERY_DOMAIN : ''}/v1.0`, // eslint-disable-line
  withCredentials: true,
  adapter: cacheAdapter,
};

if (process.env.basic_auth) {
  const authVal = process.env.basic_auth.replace(/\\/g, '');
  config.auth = JSON.parse(authVal);
}

export default config;
